export default __webpack_public_path__ + "static/media/bse-payment-activated-768.7278586a.svg";